var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card-news-agency", attrs: { id: _vm.itemId } },
    [
      _c("div", { staticClass: "d-flex head-img-title align-items-center" }, [
        _c("div", { staticClass: "flex-grow-1" }, [
          _c("span", {
            staticClass: "kicker",
            domProps: { innerHTML: _vm._s(_vm.item.header) },
          }),
          _vm._v(" "),
          _c("h2", { domProps: { innerHTML: _vm._s(_vm.item.title) } }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "read-more",
              class: { up: _vm.openContent },
              on: {
                click: function ($event) {
                  return _vm.readContent()
                },
              },
            },
            [
              _vm._v("\n        " + _vm._s(_vm.contentTagcontrol) + " "),
              _c("i", { staticClass: "icon-keyboard_arrow_down" }),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-4" }, [
          _vm.item.imageUrl
            ? _c("img", { attrs: { src: _vm.item.imageUrl } })
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "content-news-agency",
        class: { show: _vm.openContent },
        domProps: { innerHTML: _vm._s(_vm.item.content) },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "footer" }, [
        _vm.item.companyName
          ? _c("div", { staticClass: "company" }, [
              _c("strong", [_vm._v("EMPRESA: ")]),
              _vm._v(" "),
              _c("span", {
                domProps: { innerHTML: _vm._s(_vm.item.companyName) },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.item.agencyLogoUrl
          ? _c("div", { staticClass: "agency" }, [
              _c("strong", [_vm._v("Agencia: ")]),
              _vm._v(" "),
              _c("a", { attrs: { href: _vm.item.agencyUrl } }, [
                _c("img", { attrs: { src: _vm.item.agencyLogoUrl } }),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.item.relatedUrl
        ? _c(
            "a",
            {
              staticClass: "btn",
              attrs: { href: _vm.item.relatedUrl, target: "_blank" },
            },
            [_vm._v("\n    NOTA RELACIONADA\n  ")]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }